import { useEffect, useState } from 'react';

/**
 * 移动端只分两档:
 *  - phone: 抽屉式导航(顶栏汉堡触发)
 *  - desktop: 常驻左侧导航 + 流体宽度内容区
 *
 * 像桌面端一样自适应 — rail 宽度 / 字号 / 间距通过 CSS clamp 跟随屏幕流动,
 * 不再做 iPad 竖横二次切换。
 */
export type Breakpoint = 'phone' | 'desktop';

const PHONE_MAX = 767;

function resolve(width: number): Breakpoint {
  return width <= PHONE_MAX ? 'phone' : 'desktop';
}

export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(() =>
    typeof window === 'undefined' ? 'phone' : resolve(window.innerWidth),
  );

  useEffect(() => {
    function onResize(): void {
      setBp(resolve(window.innerWidth));
    }
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);

  return bp;
}
